import React from 'react';

import { Accordion, Avatar, Box, Text } from '@ublend-npm/aulaui-core';

import { EDUCATOR_ROLE } from '@core/constants/space';

import ParticipantHistoryAccordionItem from './ParticipantHistoryAccordionItem';
import { ParticipantHistoryEvent } from './types';

type ParticipantHistoryAccordionProps = {
  event: ParticipantHistoryEvent;
};

const ParticipantHistoryAccordion = ({
  event,
}: ParticipantHistoryAccordionProps) => {
  let label = event.data.length.toString();
  if (event.eventType === 'added') {
    label = `+${label}`;
  } else if (event.eventType === 'removed') {
    label = `-${label}`;
  }

  return (
    <Accordion
      key={event.eventType}
      arrowPosition="right"
      headerElement={
        <Box sx={{ py: 1, display: 'flex', gap: 1.5, alignItems: 'center' }}>
          <Avatar fallbackText={label} sx={{ width: 32, height: 32 }} />
          <Text>
            {event.data.length} users were {event.eventType} by {event.user}
          </Text>
        </Box>
      }
      label={`${event.data.length} users were ${event.eventType} by ${event.user}`}
      sx={{
        mt: 1,
        background: 'transparent',
        '& .MuiAccordionSummary-root': {
          '&:hover': { background: 'transparent' },
        },
        '& .MuiAccordionSummary-content': { ml: '0 !important' },
        '& .MuiAccordionDetails-root': {
          p: 0,
          '& > .MuiBox-root': { p: 0, maxHeight: 'none' },
        },
      }}
    >
      {event.data.map((ev) => (
        <ParticipantHistoryAccordionItem
          avatar={ev.participant.avatar}
          isEducator={ev.role === EDUCATOR_ROLE}
          firstName={ev.participant.firstName}
          lastName={ev.participant.lastName}
          eventType={ev.eventType}
        />
      ))}
    </Accordion>
  );
};

export default ParticipantHistoryAccordion;
